<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>项目中心</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="hideIsDetail = false">合作商拜访</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideIsDetail">
      <section class="searchBox">
        <span>
          <label>类型：</label>
          <a-radio-group v-model="service_type">
            <a-radio :value="1">甲方客户</a-radio>
            <a-radio :value="2">劳务经纪</a-radio>
          </a-radio-group>
        </span>
        <span v-show="service_type == 2">
          <label>劳务经纪类型：</label>
          <a-radio-group v-model="labour_type">
            <a-radio :value="1">个人</a-radio>
            <a-radio :value="2">公司</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>拜访日期：</label>
          <a-range-picker
            style="width:220px"
            v-model="date"
            :placeholder="['开始时间', '结束时间']"
            @change="onChangeDate"
          />
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            style="width:160px"
            placeholder="请输入姓名"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button style="margin-right:10px" @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.update_time.substring(0, 10) }}</td>
              <td>{{ item.visit_user_name }}</td>
              <td>{{ item.customer_user_name }}</td>
              <td>
                <p v-show="item.service_type == 1">甲方客户</p>
                <p v-show="item.service_type == 2">劳务经纪</p>
                <!-- <span v-for="(element, j) in item.customer_role_info" :key="j">
                  <span v-show="j > 0">|</span>
                  <span>{{ element.role_name }}</span>
                </span> -->
              </td>
              <td>{{ item.project_name }}</td>
              <td>
                <span v-if="item.visit_type == 1">电话</span>
                <span v-else-if="item.visit_type == 2">面访</span>
                <span v-else>社交APP</span>
              </td>
              <td style="width:40%">
                <p>{{ item.communicate }}</p>
              </td>
              <td class="operation">
                <a @click="detailPage(item)">详情</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <!-- 详情 -->
    <customerLogDetail v-show="hideIsDetail" :detail="detail" />
    <!-- 详情 end-->
  </div>
</template>
<script>
import axios from "axios";
import customerLogDetail from "@/components/management/customerLogDetail.vue";
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "日期",
        "运营姓名",
        "拜访客户",
        "类型",
        "项目",
        "拜访类型",
        "沟通记录",
        "操作"
      ],
      query_field: "",
      start_date: "",
      end_date: "",
      hideIsDetail: false,
      detail: {},
      date: null,
      service_type: 0,
      labour_type: 0
    };
  },
  components: {
    customerLogDetail
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    onChangeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      //  console.log(this.searchDate);
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      // console.log(this.start_date);
      let url =
        this.httpsBasic.url +
        this.httpsBasic.customer +
        "Customer/queryAllUserCustomerVisit";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        token: window.localStorage.getItem("xnwfPcToken"),
        start_date: this.start_date,
        end_date: this.end_date,
        service_type: this.service_type,
        labour_type: this.labour_type
      };
      if (this.start_date == "" || this.start_date == undefined) {
        delete params.start_date;
      }
      if (this.end_date == "" || this.end_date == undefined) {
        delete params.end_date;
      }
      if (this.service_type == 1 || this.service_type == 0) {
        delete params.labour_type;
      }
      axios
        .post(url, params)
        .then(res => {
          //   console.log(res);
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    detailPage(item) {
      this.hideIsDetail = true;
      this.detail = item;
    },
    onReset() {
      this.date = undefined;
      this.start_date = "";
      this.end_date = "";
      this.query_field = "";
      this.service_type = "";
      this.labour_type = "";
      this.page = 1;
      this.getData();
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.searchStyle {
  > input {
    margin: 0 20px;
    width: 200px;
  }
}
</style>
